<template>
  <section class="fast-template-detail-container">
    <el-container v-loading="loading">
      <el-main>
        <base-header
          @handleBack="handleClickBack"
          v-bind="header"
        />
        <div class="header">
          <div class="img">
            <el-image :src="$getPath(detail.url)" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="title-wrap">
            <div class="title">{{detail.modelName}}</div>
            <el-button type="primary" @click="handleCreate">立即使用</el-button>
          </div>
        </div>
        <div class="rule-wrap">
          <div class="label">采集规则：</div>
          <div class="rule">{{detail.rules}}</div>
        </div>
        <div class="data-wrap">
          <div class="label">示例数据：</div>
        </div>
        <base-table
          v-bind="list"
          :data="detail.examples"
        />
      </el-main>
    </el-container>
    <fast-dialog
      ref="fast"
      v-bind="detail"
      :modelType="modelType"
    />
  </section>
</template>
<script>
import baseTable from '@/components/mixins/baseTable'
import baseHeader from '@/components/mixins/baseHeader'
import FastDialog from './FastDialog'
import { mapActions } from 'vuex'
const columns = [
  {
    prop: 'title',
    label: '标题'
  },
  {
    prop: 'link',
    label: '文章链接'
  },
  {
    prop: 'date',
    label: '时间'
  },
  {
    prop: 'source',
    label: '来源'
  },
  {
    prop: 'content',
    label: '内容'
  }
]

export default {
  name: 'FastTemplateDetail',
  mixins: [baseTable, baseHeader],
  components: {
    FastDialog
  },
  props: {
    templateId: {
      type: [String, Number],
      default: ''
    },
    modelType: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      header: {
        showAlertIcon: false,
        buttons: [
          {
            type: 'Back',
            text: '返回',
            icon: 'fanhui'
          }
        ]
      },
      detail: {},
      list: {
        columns,
        showSelection: false,
        showPagination: false
      }
    }
  },
  watch: {
    templateId (newData, oldData) {
      if (newData && newData !== oldData) {
        this.fetchCollectTemplate()
      }
    }
  },
  methods: {
    ...mapActions('interact', ['FetchCollectTaskList']),
    handleClickBack () {
      this.$emit('click')
    },
    handleCreate () {
      this.$refs.fast.showDialog()
    },
    fetchCollectTemplate () {
      this.loading = true
      const params = {
        id: this.templateId
      }
      this.$request.fetchCollectTemplate(params).then(res => {
        if (res.code === 200) {
          this.detail = res.data
          this.FetchCollectTaskList(true)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.fetchCollectTemplate()
  }
}
</script>
<style lang="scss">
.fast-template-detail-container{
  .el-main{
    .header{
      display: flex;
      align-items: center;
      padding: 10px 0 30px;
      .img{
        width: 128px;
        height: 128px;
        border-radius: 4px;
        border: 1px solid #e8e8e8;
      }
      .title-wrap{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 20px;
        .title{
          color: #333333;
          font-size: 24px;
          line-height: 24px;
          font-weight: bold;
          padding-bottom: 18px;
        }
      }
    }
    .label{
      color: #333333;
      font-size: 16px;
      line-height: 16px;
    }
    .rule-wrap{
      .rule{
        padding-top: 18px;
        font-size: 14px;
        line-height: 14px;
        color: #666666;
      }
    }
    .rule-wrap,
    .data-wrap{
      padding: 30px 0;
      border-top: 1px solid #e8e8e8;
    }
  }
}
</style>
